import { ApplyOnlineNetworkService } from './ApplyOnlineNetworkService';
import { Init } from './models';

let applyOnlineNetworkService: ApplyOnlineNetworkService | undefined = undefined;

export const applyOnlineNetworkServiceInit = ({ baseUrl, headers, track, token }: Init) => {
  applyOnlineNetworkService = new ApplyOnlineNetworkService({ baseUrl, headers, track, token });
  return applyOnlineNetworkService;
};

export { applyOnlineNetworkService };
